/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum AlertNotificationSeverity {
    INFORMATION = 'Information',
    WARNING = 'Warning',
    ERROR = 'Error',
    SUCCESS = 'Success'
}
